export default __webpack_public_path__ + "static/media/music-note.d59aa865.svg";